export enum PageViewTypeEnum {
  PROFILE = 'Profile',
  PAGE = 'Page',
}
